import { FeatureAccessMessageType, FeatureId } from '@upright/common/iam/access/feature-access/types';
import { UserPrivate } from '@upright/common/iam/users/types';
import {
  NotAvailableCommonElements,
  NotAvailableContentType,
  NotAvailableSectionContent,
  NotAvailableSectionContentWithFeatureId,
} from './types';

export function pickNotAvailableContent(
  featureId: FeatureId,
  contentType: NotAvailableContentType,
  featureContent: NotAvailableSectionContentWithFeatureId[],
  accessMessageType: FeatureAccessMessageType = FeatureAccessMessageType.CURRENT_SUBCRIPTION_NOT_ENOUGH,
  defaultContent: NotAvailableSectionContent[],
  user: UserPrivate | undefined,
  customContent: Partial<NotAvailableCommonElements> | undefined,
) {
  const matchingFeatureContent = featureContent.find(
    item => item.featureId === featureId && item.accessMessageType === accessMessageType,
  )?.elements;

  const matchingDefault = defaultContent.find(item => item.accessMessageType === accessMessageType)?.elements;

  const { icon, title, ingress } = (() => {
    if (user) {
      return {
        icon: customContent?.icon_loggedIn ||
          customContent?.icon ||
          matchingFeatureContent?.icon_loggedIn ||
          matchingFeatureContent?.icon ||
          matchingDefault?.icon_loggedIn ||
          matchingDefault?.icon || { svgElement: <></> },
        title: customContent?.title_loggedIn ||
          customContent?.title ||
          matchingFeatureContent?.title_loggedIn ||
          matchingFeatureContent?.title ||
          matchingDefault?.title_loggedIn ||
          matchingDefault?.title || { icon: <></> },
        ingress: customContent?.ingress_loggedIn ||
          customContent?.ingress ||
          matchingFeatureContent?.ingress_loggedIn ||
          matchingFeatureContent?.ingress ||
          matchingDefault?.ingress_loggedIn ||
          matchingDefault?.ingress || { icon: <></> },
      };
    }
    return {
      icon: customContent?.icon || matchingFeatureContent?.icon || matchingDefault?.icon,
      title: customContent?.title || matchingFeatureContent?.title || matchingDefault?.title,
      ingress: customContent?.ingress || matchingFeatureContent?.ingress || matchingDefault?.ingress || <></>,
    };
  })();

  switch (contentType) {
    case NotAvailableContentType.ICON:
      return icon?.svgElement;
    case NotAvailableContentType.TITLE:
      return <>{title}</>;
    case NotAvailableContentType.INGRESS:
      return <>{ingress}</>;
  }
}
